import PrimeLogo from "./PrimeLogo";

export default PrimeLogo;
